const sendTracking = (key, value) => {
  // Track user progress
  window?.analytics?.track(key, value);
};

export default sendTracking;
